import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const TotalFieldsIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(10);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.9705 8.25009C12.229 8.25009 12.4393 8.03979 12.4393 7.7813C12.4393 7.5228 12.229 7.3125 11.9705 7.3125C11.712 7.3125 11.5017 7.5228 11.5017 7.7813C11.5017 8.03979 11.712 8.25009 11.9705 8.25009Z" fill="#1C1F28" />;
    t1 = <path d="M11.3438 11.126H12.6564V12.4699H11.3438V11.126Z" fill="#1C1F28" />;
    t2 = <path d="M6.31529 9.5507C6.53535 9.68697 6.82434 9.61912 6.96067 9.399L7.46691 8.58161V12.4696H10.4063V10.6569C10.4063 10.398 10.6162 10.1881 10.8751 10.1881H13.1253C13.3842 10.1881 13.5941 10.398 13.5941 10.6569V12.4696H16.5334V8.58161L17.0397 9.39897C17.1284 9.5422 17.2817 9.62099 17.4387 9.62099C17.5229 9.62099 17.6082 9.59827 17.6851 9.55067C17.9052 9.41435 17.9731 9.12538 17.8368 8.9053L16.0458 6.01361C15.9995 5.93876 15.933 5.8785 15.8539 5.83968L12.2069 4.04804C12.0765 3.98397 11.9238 3.984 11.7935 4.04804L8.14638 5.83968C8.06737 5.8785 8.0009 5.93876 7.95455 6.01361L6.16359 8.9053C6.02723 9.12541 6.09518 9.41435 6.31529 9.5507ZM11.9689 6.37521C12.7444 6.37521 13.3753 7.00611 13.3753 7.78159C13.3753 8.55708 12.7444 9.18798 11.9689 9.18798C11.1934 9.18798 10.5625 8.55708 10.5625 7.78159C10.5625 7.00611 11.1934 6.37521 11.9689 6.37521Z" fill="#1C1F28" />;
    t3 = <path d="M4 17.1885V18.1261H8.59667C8.76656 17.8036 8.95227 17.4908 9.15282 17.1885H4Z" fill="#1C1F28" />;
    t4 = <path d="M10.729 15.3135H4V16.2511H9.8502C10.1242 15.9217 10.4176 15.6086 10.729 15.3135Z" fill="#1C1F28" />;
    t5 = <path d="M11.8594 14.3795C12.0206 14.2636 12.185 14.1517 12.3529 14.0444C12.7228 13.808 13.105 13.5957 13.4973 13.4077H4.4688C4.2099 13.4077 4 13.6176 4 13.8765V14.3766H11.8085C11.8257 14.3766 11.8427 14.3776 11.8594 14.3795Z" fill="#1C1F28" />;
    t6 = <path d="M4 19.5258C4 19.7847 4.2099 19.9946 4.4688 19.9946H8.02196C8.04596 19.6795 8.10465 19.3663 8.19616 19.063H4V19.5258Z" fill="#1C1F28" />;
    t7 = <path d="M19.5311 13.4077H16.6632C13.5204 13.8884 10.7221 15.9066 9.29374 18.8204C9.1135 19.1881 9.0008 19.5893 8.96143 19.9961H19.5311C19.79 19.9961 19.9999 19.7862 19.9999 19.5273V13.8765C19.9999 13.6176 19.79 13.4077 19.5311 13.4077Z" fill="#1C1F28" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== props) {
    t8 = <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[8] = props;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};